import { store } from 'Models/Store'
import { EnforceOnlinePaymentField } from './Gibs/EnforceOnlinePaymentField'
import { OrganisationEntity } from 'Models/Entities'


type Props = {
	organisation: OrganisationEntity;
}

export const OrganisationBillingFields: React.FunctionComponent<Props> = ({ organisation }) => {
	const isReadOnly = store.userType !== "SUPER_USER";

	return (
		<div className="container">
			<div className="title">
				<h4>Billing</h4>
			</div>
			<div className="billing-fields">
				<EnforceOnlinePaymentField
					initialEnforcePaymentValue={organisation.enforceOnlinePayments}
					organisationId={organisation.id}
					isReadOnly={isReadOnly}
				/>
			</div>
		</div>
	)
}

